export const IVA_TAX_ID = '1'
export const IGIG_TAX_ID = '2'

export const TAXES_BY_ID = {
  [String(IVA_TAX_ID)]: {
    name: 'COMMON.TAXES.IVA',
    percentage: 21
  },
  [String(IGIG_TAX_ID)]: {
    name: 'COMMON.TAXES.IGIG',
    percentage: 10
  }
}
